import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d6f1e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bundle-info-popup" }
const _hoisted_2 = { class: "bundle-info-popup__title" }
const _hoisted_3 = ["disabled"]

import { nextTick, ref, Ref } from "vue";
import MainLoader from "@/components/MainLoader.vue";
import { Bundle, useBundleStore } from "@/stores/bundle";
import router from "@/router";
import { requestedCountriesFromUrl } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupBundleInfoLoading',
  props: {
  error: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const bundleStore = useBundleStore();
const bundlesLoading: Ref<boolean> = ref(false);

async function goSearch(): Promise<void> {
  bundlesLoading.value = true;
  bundleStore.countries = requestedCountriesFromUrl();
  const newBundles: Bundle[] = await bundleStore.getBundles(
    bundleStore.duration || 1,
    bundleStore.countries
  );
  await nextTick(() => {
    bundleStore.bundles = newBundles;
    router.push("/");
    bundlesLoading.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.error)
      ? (_openBlock(), _createBlock(MainLoader, {
          key: 0,
          primary: ""
        }))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.error
          ? "Error occurred. This bundle is no longer available. Please try again"
          : "Proceeding to Stripe"), 1),
    (__props.error)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-b btn-max btn-danger",
          onClick: goSearch,
          disabled: bundlesLoading.value
        }, [
          _createTextVNode(" Go to search "),
          (bundlesLoading.value)
            ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})